exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-10{position:relative;width:100%;height:100%;border-radius:6px}.dv-border-box-10 .dv-border-svg-container{position:absolute;display:block}.dv-border-box-10 .right-top{right:0;transform:rotateY(180deg)}.dv-border-box-10 .left-bottom{bottom:0;transform:rotateX(180deg)}.dv-border-box-10 .right-bottom{right:0;bottom:0;transform:rotateX(180deg) rotateY(180deg)}.dv-border-box-10 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox10/src/main.css
// module id = 1068
// module chunks = 45